export interface GuardianForm {
  name: string,
  description: string,
  expiration: Date,
  status: GuardianFormStatus,
  allGuardianSignaturesRequired: boolean,
  fields: GuardianFormField[]
}

export interface GuardianFormField {
    id: string,
    order: number,
    name: string,
    description?: string,
    valueType: GuardianFormFieldType,
    options?: string,
    isRequired: boolean,
    allGuardianSignaturesRequired?: boolean
}

export enum GuardianFormStatus {
    Draft = 0,
    Active = 1,
    Expired = 2
}

export enum GuardianFormFieldType {
    Number = 1,
    ShortString,
    LongString,
    DateTimeOffset,
    Bool,
    Dropdown,
    Multiselect,
    File,
    TextArea,
    Signature,
    PhoneNumber,
    GuardianSignature
}